<template>
  <section class="extras-wrapper" :class="{ desktop: $isDesktop }">
    <div v-if="extras.length > 0" class="extras">
      <slot name="extras-title">
        <translate tag="h4"> Extras </translate>
      </slot>
      <table class="extras-table">
        <tbody>
          <template v-for="extra in sortedExtras">
            <slot name="extra" :extra="extra" />
          </template>
        </tbody>
      </table>
      <translate tag="p">
        You will be able to choose extras on the booking page.
      </translate>
    </div>
  </section>
</template>

<script lang="ts">
/* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return */
import {
  ChargeTypeExtra,
  PitchTypeExtra,
} from '../../../../campsite-details/types'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class Extras extends Vue {
  @Prop({ required: true })
  extras: ChargeTypeExtra[] | PitchTypeExtra[]

  get sortedExtras() {
    return this.extras.sort((a, b) => {
      if (a.compulsory === b.compulsory) {
        return a.name.localeCompare(b.name)
      }
      return a.compulsory ? -1 : 1
    })
  }
}

export default toNative(Extras)
</script>
<style scoped>
.extras-wrapper {
  background-color: #eef2f7;
  margin: 0 -1em;
  padding: 1em;
}

.extras {
  background: white;
  border-radius: 0.5em;
  padding: 0.2em 0.8em 0.5em;
}

.extras :deep(h4) {
  margin-top: 0.5em;
}

table {
  margin-top: 0.4em;
  border-top: 1px solid var(--colour-page-background);
}

p {
  margin: 0.4em 0 0;
}

.extras-table :deep(.display-price) {
  color: var(--colour-dark-blue);
}

/* desktop & tablet */
.extras-wrapper.desktop {
  background-color: white;
  margin: 0;
  padding: 0;
}

.desktop .extras {
  border-radius: 0;
  padding: 0;
}
</style>
